module.exports = __webpack_public_path__ + "img/4417108_128.72322b8a.png";